module.exports = __webpack_public_path__ + "media/images/logo-70fdc80e85ba259444ea88437ed3fd92.png";